import { render, staticRenderFns } from "./IconNew.vue?vue&type=template&id=5e08ff09&"
import script from "./IconNew.vue?vue&type=script&lang=js&"
export * from "./IconNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports